export enum ActivityFeedSettingIds {
    unknown = 0,
    flightNotification = 11,
    parcelNotification = 15,
    emailMentionNotification = 2,
    documentMentionNotification = 18,
    RealTimeFlightUpdate = 19,
    MyAnalyticsTaskNotificationInsight = 20,
    MyAnalyticsFollowUpNotificationInsight = 21,
    OutOfRoutineNotification = 22,
    likeNotification = 1,
}

export interface ActivityFeedSettingsResponse {
    name: string;
    value: string;
    timestamp: number;
}
